/**
 * 「このコードは使えませんでしたが、アカウントはできました」の案内（2026-10-29 core/open-signup-build・指示書 open-signup-build の 1）。
 * 招待なしの本体（サーバーの KUMO_SIGNUP_REQUIRES_INVITE=false・10/31 から本番）で、登録に付けたコードが使えなかったとき
 * （応答の inviteNotApplied・inviteCode.ts の inviteNotAppliedReason）に、登録の 3 つの画面で同じ形で出す:
 *   pages/AuthPage.tsx（メールの登録）・pages/OAuthCallback.tsx（Google / GitHub の戻り）・pages/CreatorStart.tsx（作り手を始める）。
 * WHY 進む前に 1 枚はさむか: そのまま進むと「コードを入れたのにクレジットが無い」と後で気付く（入金を求められて初めて分かる）。
 *   founder 10/29「招待コードはクレジット獲得のみ」= 登録は失敗していない、と先に言い、別のコードは後で前払い残高の画面（Billing）で入れられると添える。
 * 本文は箱 1 つ（2026-10-29 core/open-signup-polish・Rauno 役）: 「なぜクレジットが入らなかったか」+「次にできること」（inviteCode.ts notAppliedCopy）。
 *   以前は箱の下に理由の文（error.<code>）を小さく 1 行足していたが、「アカウントはできた」の箱と「打ち間違いを確かめて」が二重で、
 *   アカウントができた後に「打ち間違いを確かめて」は意味がずれていた。見出しが「できた」を言うので本文では繰り返さない
 */
import { useT } from '../i18n';
import { notAppliedCopy, type InviteError } from '../inviteCode';

/** 前払い残高の画面の招待コードの欄（components/InviteCodeCard.tsx の id）。ホームの「招待コードがあれば」のリンクも同じ所へ */
export const INVITE_CODE_PATH = '/money/prepaid#invite-code';

/**
 * onContinue = いつもの行き先へ（ログインを済ませて進む）・onBilling = 前払い残高の画面の招待コードの欄へ（同じくログインを済ませて INVITE_CODE_PATH へ）。
 * WHY どちらも呼ぶ側に任せるか: メールの登録と作り手を始めるは、この 1 枚の時点でまだログインの前（signIn で画面の木が替わると、この 1 枚が消える）
 */
export function InviteNotAppliedNotice({
  reason,
  fromAd = false,
  onContinue,
  onBilling
}: {
  reason: InviteError | 'unknown';
  fromAd?: boolean;
  onContinue: () => void;
  onBilling: () => void;
}) {
  const { t } = useT();
  const copy = notAppliedCopy(reason, fromAd);
  return (
    <>
      <h2>{t('invite.notApplied.title')}</h2>
      <p className="alert alert-info" role="status">
        {t('invite.notApplied.body', { lead: t(`invite.notApplied.lead.${copy.lead}`), tail: t(`invite.notApplied.tail.${copy.tail}`) })}
      </p>
      <button type="button" className="btn btn-primary btn-block" onClick={onContinue}>
        {t('recover.continue')}
      </button>
      <button type="button" className="btn btn-ghost btn-block" onClick={onBilling}>
        {t('invite.notApplied.billing')}
      </button>
    </>
  );
}
